import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch } from 'react-router'
import loadable from '@loadable/component'
import routes from '@utils/constants/routes'
import { loadableOptions } from '@components/App'
import { RootState } from '@app-store/store'
import { STATUS } from '@features/General'

const Signup = loadable(() => import('@components/Auth/Register/Signup'), loadableOptions)
const EmailConfirm = loadable(() => import('components/Auth/Register/EmailConfirm'), loadableOptions)
const MeetingHubEmailConfirm = loadable(
    () => import('components/Auth/Register/EmailConfirm/MeetingHub'),
    loadableOptions
)

function Register() {
    const { data, status } = useSelector((state: RootState) => state.events.oneEventByDomain)
    return (
        <>
            {status !== STATUS.RUNNING && (
                <Switch>
                    <Route
                        exact
                        path={routes.sign_up._}
                        component={() => <Signup isMeetingHub={data?.isMeetingHubEvent} />}
                    />
                    <Route
                        exact
                        path={routes.sign_up.email_confirm._}
                        component={() => (
                            <>
                                {data?.isMeetingHubEvent ? (
                                    <MeetingHubEmailConfirm isSubscription={false} />
                                ) : (
                                    <EmailConfirm />
                                )}
                            </>
                        )}
                    />
                </Switch>
            )}
        </>
    )
}

export default Register
